import React from "react";

function Collaboration() {
  return (
    <section id="collab" className="collab">
      <div className="section">
        <div>
          <span className="eyebrow" data-reveal>
            商务合作 · PARTNERSHIP
          </span>
          <h2 className="section-title" data-reveal data-reveal-delay="1">
            两种方式 <em>与我们共建</em>。
          </h2>
          <p className="section-lede" data-reveal data-reveal-delay="2">
            慧声同时面向上游的 IP / 工作室和下游的发行方开放合作通道 ——
            既可以与我们一同探索互动影视游戏的新形态，也可以把成熟漫剧项目交给我们的
            AIGC 制作团队。
          </p>

          <div className="collab__ways" data-reveal data-reveal-delay="3">
            <div className="collab__way">
              <div className="collab__way-num">01</div>
              <div className="collab__way-body">
                <h3>接待漫剧工作室与互动影游团队</h3>
                <p>
                  面向漫剧工作室、想要尝试互动影视 / 游戏化形态的内容方与 IP
                  方,提供平台、技术与发行的整链路支持。
                </p>
              </div>
            </div>
            <div className="collab__way">
              <div className="collab__way-num">02</div>
              <div className="collab__way-body">
                <h3>承接精品漫剧制作</h3>
                <p>
                  我们拥有专业的 AIGC 制作团队 —
                  可承接精品漫剧的全流程制作,稳定输出风格统一、产能可控的高品质内容。
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="collab__panel" data-reveal data-reveal-delay="2">
          <span className="collab__label">商务邮箱 · BUSINESS</span>
          <a
            className="collab__email"
            href="mailto:zhangyuntian@soundwisdomai.com"
          >
            zhangyuntian@<br />soundwisdomai.com
          </a>
          <p className="collab__hint">
            欢迎来信咨询合作 — 通常 24 小时内回复。
          </p>

          <a
            className="btn btn--primary"
            href="mailto:zhangyuntian@soundwisdomai.com?subject=%E5%95%86%E5%8A%A1%E5%90%88%E4%BD%9C%E6%84%8F%E5%90%91"
            style={{ marginTop: 28 }}
          >
            发起合作 <span className="arrow">→</span>
          </a>
        </div>
      </div>
    </section>
  );
}

export default Collaboration;
